import { ReactComponent as GroupIcon } from "./group.svg";
import { ReactComponent as NextWeekIcon } from "./next_week.svg";
import { ReactComponent as LisenceIcon } from "./license.svg";
import { ReactComponent as AssignmentIcon } from "./assignment.svg";
import { ReactComponent as LogoutIcon } from "./logout.svg";
import { ReactComponent as ArrowUpIcon } from "./arrow_up.svg";
import { ReactComponent as ArrowDownIcon } from "./arrow_down.svg";
import { ReactComponent as UnfoldMoreIcon } from "./unfold_more.svg";
import { ReactComponent as DirectionsBoatIcon } from "./directions_boat.svg";
import { ReactComponent as NotificationsIcon } from "./notifications.svg";
import { ReactComponent as MonitoringIcon } from "./monitoring.svg";
import { ReactComponent as DomainIcon } from "./domain.svg";
import { ReactComponent as ListAltIcon } from "./list_alt.svg";
import { ReactComponent as MoreVertIcon } from "./more_vert.svg";
import { ReactComponent as MarkEmailReadIcon } from "./mark_email_read.svg";
import { ReactComponent as BadgeIcon } from "./badge.svg";
import { ReactComponent as AdminPanelSettingsIcon } from "./admin_panel_settings.svg";
import { ReactComponent as QueryStatsIcon } from "./query_stats.svg";
import { ReactComponent as CalendarMonthIcon } from "./calendar_month.svg";
import { ReactComponent as GraphicEqIcon } from "./graphic_eq.svg";
import { ReactComponent as RubricIcon } from "./rubric.svg";
import { ReactComponent as RocketLaunchIcon } from "./rocket_launch.svg";
import { ReactComponent as HotelClassIcon } from "./hotel_class.svg";
import { ReactComponent as Diversity2Icon } from "./diversity_2.svg";
import { ReactComponent as BoltIcon } from "./bolt.svg";
import { ReactComponent as EventListIcon } from "./event_list.svg";
import { ReactComponent as PaidIcon } from "./paid.svg";
import { ReactComponent as PersonAddIcon } from "./person_add.svg";
import { ReactComponent as TrophyIcon } from "./trophy.svg";
import { ReactComponent as SentimentSatisfiedIcon } from "./sentiment_satisfied.svg";
import { ReactComponent as AccountBoxIcon } from "./account_box.svg";
import { ReactComponent as CorporateFareIcon } from "./corporate_fare.svg";
import { ReactComponent as Diversity3Icon } from "./diversity_3.svg";
import { ReactComponent as ShieldPersonIcon } from "./shield_person.svg";
import { ReactComponent as DescriptionIcon } from "./description.svg";
import { ReactComponent as OutgoingEmailIcon } from "./outgoing_mail.svg";
import { ReactComponent as ChecklistIcon } from "./checklist.svg";
import { ReactComponent as CardiologyIcon } from "./cardiology.svg";
import { ReactComponent as ContactEmailIcon } from "./contact_mail.svg";
import { ReactComponent as NotificationMultipleIcon } from "./notification_multiple.svg";
import { ReactComponent as Flag } from "./flag.svg";
import { ReactComponent as Corporate } from "./corporate.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as CloseIcon } from "./close.svg";
import { ReactComponent as CompanyAccountIcon } from "./PageHeaderIcons/company_account.svg";
import { ReactComponent as ActionsOverviewIcon } from "./actions_overview.svg";
import { ReactComponent as OcenaIvCounterIcon } from "./ocenaIv_counter.svg";
import { ReactComponent as ProgramCounterIcon } from "./program_counter.svg";
import { ReactComponent as UpdatesCounterIcon } from "./updates_counter.svg";
import { ReactComponent as SurveysCounterIcon } from "./surveys_counter.svg";
import { ReactComponent as EventsCounterIcon } from "./events_counter.svg";
import { ReactComponent as RewardsCounterIcon } from "./rewards_counter.svg";
import { ReactComponent as QuoteIcon } from "./quote.svg";
import { ReactComponent as ActionsOverviewQuoteIcon } from "./actions_overview_quote.svg";
import { ReactComponent as RoadMapIcon } from "./roadmap.svg";
import { ReactComponent as PinIconGreen } from "./pin_green.svg";
import { ReactComponent as PinIconRed } from "./pin_red.svg";
import { ReactComponent as PinIconYellow } from "./pin_yellow.svg";
import { ReactComponent as PinIconPurple } from "./pin_purple.svg";
import { ReactComponent as OverviewFooterQuoteIcon } from "./overview-footer.svg";
import { ReactComponent as ActionsOverviewFooterIcon } from "./actions_overview_footer.svg";
import { ReactComponent as AwarnessStageIcon } from "./PageHeaderIcons/awarness_stage.svg";
import { ReactComponent as AwarnessFooterIcon } from "./awarness_footer.svg";
import { ReactComponent as CompletedStageIcon } from "./completed_stage.svg";
import { ReactComponent as PolicyCommitmentStageIcon } from "./PageHeaderIcons/policy_commitment_stage.svg";
import { ReactComponent as PolicyCommitmentIcon } from "./policy_commitment.svg";
import { ReactComponent as PlanningActionsIcon } from "./PageHeaderIcons/planning_actions.svg";
import { ReactComponent as PlanningAndActionsIcon } from "./planning_and_actions.svg";
import { ReactComponent as EvaluationReportingIcon } from "./evaluation_reporting.svg";

export const Icons = {
  GroupIcon,
  NextWeekIcon,
  MarkEmailReadIcon,
  LisenceIcon,
  AssignmentIcon,
  LogoutIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  UnfoldMoreIcon,
  CloseIcon,
  DirectionsBoatIcon,
  NotificationsIcon,
  MonitoringIcon,
  AdminPanelSettingsIcon,
  DomainIcon,
  ListAltIcon,
  MoreVertIcon,
  BadgeIcon,
  QueryStatsIcon,
  CalendarMonthIcon,
  GraphicEqIcon,
  RubricIcon,
  RocketLaunchIcon,
  HotelClassIcon,
  Diversity2Icon,
  BoltIcon,
  EventListIcon,
  PaidIcon,
  PersonAddIcon,
  TrophyIcon,
  SentimentSatisfiedIcon,
  AccountBoxIcon,
  CorporateFareIcon,
  Diversity3Icon,
  ShieldPersonIcon,
  DescriptionIcon,
  OutgoingEmailIcon,
  ChecklistIcon,
  CardiologyIcon,
  ContactEmailIcon,
  NotificationMultipleIcon,
  Flag,
  Corporate,
  Search,
  CompanyAccountIcon,
  ActionsOverviewIcon,
  OcenaIvCounterIcon,
  ProgramCounterIcon,
  UpdatesCounterIcon,
  SurveysCounterIcon,
  EventsCounterIcon,
  RewardsCounterIcon,
  ActionsOverviewFooterIcon,
  QuoteIcon,
  RoadMapIcon,
  PinIconGreen,
  PinIconRed,
  PinIconYellow,
  PinIconPurple,
  OverviewFooterQuoteIcon,
  AwarnessStageIcon,
  AwarnessFooterIcon,
  CompletedStageIcon,
  PolicyCommitmentStageIcon,
  PolicyCommitmentIcon,
  PlanningActionsIcon,
  PlanningAndActionsIcon,
  EvaluationReportingIcon,
};
